import { Eye, Heart, MessageSquare } from "lucide-react";

function Stat({ label, value, icon }) {
  return (
    <div className="border-r-2 border-b-2 border-black p-4 bg-white">
      <div className="font-mono-data text-xs uppercase text-gray-600 flex items-center gap-1">{icon}{label}</div>
      <div className="font-display text-4xl mt-1">{value}</div>
    </div>
  );
}

export function StatsGrid({ stats }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 border-l-2 border-t-2 border-black mt-6" data-testid="dashboard-stats">
      <Stat label="My Listings" value={stats.total} />
      <Stat label="Total Views" value={stats.views} icon={<Eye size={14} />} />
      <Stat label="Saved Items" value={stats.favorites} icon={<Heart size={14} />} />
      <Stat label="Conversations" value={stats.messages} icon={<MessageSquare size={14} />} />
    </div>
  );
}
